import { getInvoiceConfigForMarket } from '@/API/repositories/invoiceConfig';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useState, useEffect } from 'react';

export const useInvoiceConfigForCountry = (marketShort) => {
	const [invoiceConfig, setInvoiceConfig] = useState(null);
	const { makeRequest } = useRequestsContext();

	const fetchConfig = async () => {
		try {
			const response = await makeRequest(
				getInvoiceConfigForMarket.bind(null, { marketShort }),
			);
			setInvoiceConfig(response?.data);
		} catch (error) {
			console.error('Failed to fetch invoice config:', error);
		}
	};

	useEffect(() => {
		if (marketShort) {
			fetchConfig();
		}
	}, [marketShort]);

	return { invoiceConfig };
};
